import React from 'react';
import PropTypes from 'prop-types';

import VMEventView from '@package/components/Views/EventView/EventView';

const EventView = ({ content, location }) => {
  return <VMEventView content={content} location={location} />;
};

EventView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        url: PropTypes.string,
        image: PropTypes.object,
        image_caption: PropTypes.string,
        '@type': PropTypes.string,
      }),
    ),
  }).isRequired,
};

export default EventView;
